const faqs = [
  {
    q: '51吃瓜app是什么？',
    a: '51吃瓜app是国内领先的热门人物吃瓜内容聚合平台。我们专注台北娜娜、莫里秀、玩偶姐姐等热门人物，提供最新的独家爆料、视频合集和深度分析，是200万+吃瓜群众的每日必刷平台。',
  },
  {
    q: '如何第一时间看到台北娜娜的最新动态？',
    a: '在51吃瓜app中关注台北娜娜专题，开启推送通知即可。我们的内容团队7×24小时追踪，确保台北娜娜的每一条新动态都在第一时间推送到你的手机。也可以通过"专题合集"中的"台北娜娜全追踪"入口查看所有已发布内容。',
  },
  {
    q: '莫里秀合集在哪里查看？',
    a: '莫里秀的完整合集可以在首页"专题合集"模块中找到"莫里秀独家合集"入口，也可以直接在"精彩视频"中浏览所有莫里秀相关视频。我们整理了从早期到最新的全部内容，按时间线排列，方便查阅。',
  },
  {
    q: '玩偶姐姐的内容更新频率如何？',
    a: '玩偶姐姐的动态更新频率取决于其本人的发布节奏。51吃瓜app会在第一时间跟进并推送通知。你可以在"热门爆料"和"焦点专题"中查看所有关于玩偶姐姐的最新分析和深度报道。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[900px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            常见问题
          </h2>
          <p className="text-foreground-500 text-sm md:text-base">
            关于51吃瓜app的常见疑问，这里都有答案
          </p>
        </div>

        <div className="space-y-3">
          {faqs.map((item, i) => (
            <div key={i} className="bg-background-50 rounded-xl p-5 md:p-6">
              <h3 className="font-heading text-base font-bold text-foreground-900 mb-2.5">
                {item.q}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {item.a}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}